import PedidosPrepararService from "@/services/PedidosPrepararService";

/**
 * Vuex module for the bulk "Marcar como Preparado" action (Trello #416),
 * used from AdminVentas.vue (pantalla "Ventas realizadas").
 *
 * Shape follows the gold reference: store/modules/customers.js (also mirrors
 * store/modules/facturacionPedido.js)
 * - Namespaced
 * - state() factory (avoids shared reference across tests)
 * - SCREAMING_SNAKE synchronous mutations
 * - async/await action with SET_LOADING in finally
 * - Errors are re-thrown to the caller (component/global toast handles UI)
 */

const state = () => ({
  loading: false,
  error: null,
});

const getters = {};

const actions = {
  /**
   * Moves the given pedidos from estado 4 (En facturación) to 7 (Preparado).
   * Not atomic on the backend: the response can report partial success via
   * movidos/omitidos/fallidos — the caller is responsible for showing that.
   */
  async marcarPreparado({ commit }, pedidos) {
    try {
      commit("SET_LOADING", true);
      const response = await PedidosPrepararService.marcarPreparado(pedidos);
      commit("SET_ERROR", null);
      return response.data;
    } catch (error) {
      commit("SET_ERROR", error.message || "Error al marcar los pedidos como preparados");
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },
};

const mutations = {
  SET_LOADING(state, value) {
    state.loading = value;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
